/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface CreateIRRSpec { 
    irr_name: string;
    /**
     * Requested Deployment version
     */
    version?: string;
    region: AWSRegionsEnum;
    service_type: ServiceTypeEnum;
    /**
     * List of personas being deployed
     */
    personas: Array<VcdsPersonaEnum>;
    /**
     * Java Run Time version
     */
    jre_version?: string;
    /**
     * Lambda Zip file name
     */
    lambda_zip_file_name?: string;
    preferred_az_id: string;
}
export namespace CreateIRRSpec {
}


